import { useDispatch } from 'react-redux';
import tenantAxiosInstance from '../utils/tenantAxiosInstance';
import { setMessage } from '../slices/alertMessageSlice';
const API_URL = process.env.REACT_APP_BACKEND_URL;
const version = 'v1';

const getJobsList = async (tenant_id) => {
  return tenantAxiosInstance
    .get(API_URL + `enterprise/job/list/${tenant_id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // console.log('error', error);
      throw error;
    });
};
const getAllReportJobsList = async (tenant_id) => {
  return tenantAxiosInstance
    .get(API_URL + `get_all_enterprise_jobs/${tenant_id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // console.log('error', error);
      throw error;
    });
};

const getIndividualJobsList = async (tenant_id, job_id) => {
  return tenantAxiosInstance
    ?.get(API_URL + `enterprise/job/upload/${tenant_id}/${job_id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

const createNewJobId = async (tenant_id, body) => {
  return tenantAxiosInstance
    ?.post(API_URL + `enterprise/job/create/${tenant_id}`, body)
    .then((response) => {
      // console.log(response);
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

const createNewJobUpload = async (tenant_id, job_id, body) => {
  return tenantAxiosInstance
    ?.post(API_URL + `enterprise/job/upload/${tenant_id}/${job_id}`, body)
    .then((response) => {
      // console.log(response);
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

const createJobMappings = async ({ tenant_id, job_id, job_file_id, body }) => {
  // console.log(tenant_id, job_id, job_file_id, body);
  return tenantAxiosInstance
    ?.post(
      API_URL + `enterprise/job/mapping/${tenant_id}/${job_id}/${job_file_id}`,
      body
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

const jobValidate = async ({ tenant_id, job_id, job_file_id }) => {
  // console.log(tenant_id, job_id, job_file_id);
  return tenantAxiosInstance
    ?.get(
      API_URL + `enterprise/job/validate/${tenant_id}/${job_id}/${job_file_id}`
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

const completeJob = async ({ tenant_id, job_id, job_file_id }) => {
  // console.log(tenant_id, job_id, job_file_id);
  return tenantAxiosInstance
    ?.get(
      API_URL + `enterprise/job/complete/${tenant_id}/${job_id}/${job_file_id}`
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};
const getJobData = async ({ tenant_id, job_id }) => {
  return tenantAxiosInstance
    ?.get(API_URL + `enterprise/job/${tenant_id}/${job_id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

const getJobMapping = async ({ tenant_id, job_id }) => {
  return tenantAxiosInstance
    ?.get(API_URL + `enterprise/job/mapping/${tenant_id}/${job_id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

const getJobSummary = async ({ tenant_id, job_id, job_file_id }) => {
  // console.log(tenant_id, job_id, job_file_id);
  return tenantAxiosInstance
    ?.get(
      API_URL +
        `enterprise/job/profile/summary/${tenant_id}/${job_id}/${job_file_id}`
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

const getJobInsights = async ({ tenant_id, job_id, job_file_id, body }) => {
  // console.log(tenant_id, job_id, job_file_id, body);
  return tenantAxiosInstance
    ?.post(
      API_URL +
        `enterprise/job/profile/insights/${tenant_id}/${job_id}/${job_file_id}`,
      body
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

const completeJobAction = async ({ tenant_id, job_id, job_file_id, body }) => {
  // console.log(tenant_id, job_id, job_file_id, body);
  return tenantAxiosInstance
    ?.post(
      API_URL + `enterprise/job/action/${tenant_id}/${job_id}/${job_file_id}`,
      body
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

const getJobActions = async ({ tenant_id, job_id, job_file_id }) => {
  // console.log(tenant_id, job_id, job_file_id);
  return tenantAxiosInstance
    ?.get(
      API_URL + `enterprise/job/audit/${tenant_id}/${job_id}/${job_file_id}`
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};


const enterPriseDelete = (tenant_id, job_id) => {
  return tenantAxiosInstance
    .delete(
      API_URL +
        `eneterprise_report/delete/${tenant_id}/${job_id} `
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error('Request Error:', error);
      throw error;
    });
};

const getEnterpriseTable = async ({ tenant_id, job_id }) => {
  // console.log(tenant_id, job_id, job_file_id);
  return tenantAxiosInstance
    ?.get(
      API_URL + `get_enterprise_data/job/${tenant_id}/${job_id}`
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};
const enterpriseReport = async ({ tenant_id, job_id }) => {
  // console.log(tenant_id, job_id, job_file_id);
  return tenantAxiosInstance
    ?.post(
      API_URL + `get_enterprise_report/job/${tenant_id}/${job_id}`,
        {}
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

const undoJobActions = async ({ tenant_id, job_id, job_file_id }) => {
  // console.log(tenant_id, job_id, job_file_id);
  return tenantAxiosInstance
    ?.get(
      API_URL +
        `enterprise/job/audit/undo/${tenant_id}/${job_id}/${job_file_id}`
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};
const EnterPriceService = {
  getJobsList,
  getIndividualJobsList,
  createNewJobId,
  createNewJobUpload,
  createJobMappings,
  jobValidate,
  completeJob,
  getJobData,
  getJobSummary,
  getJobMapping,
  getJobInsights,
  completeJobAction,
  getJobActions,
  undoJobActions,
  enterpriseReport,
  getEnterpriseTable,
  getAllReportJobsList,
  enterPriseDelete
};
export default EnterPriceService;
